import React, { useMemo, useState } from 'react'
import { Button, Modal, Spinner } from 'react-bootstrap'
import NonlalinService from '../../../services/nonlalin/NonlalinService'
import SweetAlert from 'react-bootstrap-sweetalert'

const ModalLhpNonLalinDetilPeriksa = ({ showLhpDetil, handleCLoseModalLhpDetil, dataLhpPeriksa, idLhpHdr }) => {

    let nonLalinService = useMemo(() => new NonlalinService(), [])

    const [valueJmlSample, setValueJmlSample] = useState(0)
    const [valueJmlUji, setValueJmlUji] = useState(0)
    const [valueHasilUji, setValueHasilUji] = useState(null)

    const onChangeJmlSample = e => {
        setValueJmlSample(e.target.value)
    }
    const onChangeJmlUji = e => {
        setValueJmlUji(e.target.value)
    }
    const onChangeHasilUji = e => {
        setValueHasilUji(e.target.value)
    }

    const [showConfirmSaveDtl, setShowConfirmSaveDtl] = useState(false)
    const handleCloseConfirmSaveDtl = () => setShowConfirmSaveDtl(false)
    const [loadingSave, setLoadingSave] = useState(false)
    const handleConfirmSaveDtl = () => {
        setShowConfirmSaveDtl(true)
    }
    const [showSaveSuccess, setShowSaveSuccess] = useState(false)
    const [showSaveFailed, setShowSaveFailed] = useState(false)
    const handleClickSaveDtl = async () => {
        setLoadingSave(true)
        try {
            let jsonLhpDtl = {
                idLhp: idLhpHdr,
                nomorAju: dataLhpPeriksa.trNonlalinDtlPeriksaPK.nomorAju,
                seri: dataLhpPeriksa.trNonlalinDtlPeriksaPK.seri,
                seriTarif: dataLhpPeriksa.trNonlalinDtlPeriksaPK.seriTarif,
                kdTarif: dataLhpPeriksa.kdTarif,
                nmTarif: dataLhpPeriksa.nmTarif,
                jumlahSample: valueJmlSample,
                jumlahPengujian: valueJmlUji,
                hasilPengujian: valueHasilUji,
                createdBy: localStorage.getItem("userId"),
                createdDate: new Date()
            }
            const _resDtl = await nonLalinService.saveNonlalinLhpDetail(jsonLhpDtl)
            if (_resDtl.data.kode === '200') {
                setShowConfirmSaveDtl(false)
                setShowSaveSuccess(true)
            } else {
                setShowSaveFailed(true)
                setShowConfirmSaveDtl(false)
            }
        } catch (error) {
            setShowSaveFailed(true)
            setShowConfirmSaveDtl(false)
        }
        setLoadingSave(false)
    }
    const handleClickSaveSuccess = () => {
        setShowConfirmSaveDtl(false)
        setShowSaveSuccess(false)
        handleCLoseModalLhpDetil()
    }
    const handleClickSaveFailed = () => {
        setShowConfirmSaveDtl(false)
        setShowSaveFailed(false)
    }

    return (
        <>
            <Modal
                show={showLhpDetil}
                onHide={handleCLoseModalLhpDetil}
                backdrop='static'
                size='md'
                centered
            >
                <Modal.Header>
                    <Modal.Title><h6>Proses Hasil Laboratorium</h6></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row mb-3">
                        <div className='col-12'>
                            <label className="col-sm-6 col-form-label-sm">Jenis Pemeriksaan</label>
                            <div className="col-sm-12">
                                <input type="text" className="col-sm-12 form-control-sm" name="nmTarif" defaultValue={dataLhpPeriksa ? dataLhpPeriksa.nmTarif : ''} disabled />
                            </div>
                        </div>
                    </div>
                    <div className="row mb-3">
                        <div className='col-6'>
                            <label className="col-sm-6 col-form-label-sm">Jumlah Sample</label>
                            <div className="col-sm-12">
                                <input type="text" className="col-sm-6 form-control-sm" name="jmlSample" value={valueJmlSample} onChange={onChangeJmlSample} />
                            </div>
                        </div>
                        <div className='col-6'>
                            <label className="col-sm-6 col-form-label-sm">Jumlah Pengujian</label>
                            <div className="col-sm-12">
                                <input type="text" className="col-sm-6 form-control-sm" name="jmlUji" value={valueJmlUji} onChange={onChangeJmlUji} />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="form-group">
                                <label className="col-form-label-sm">Hasil Pengujian</label>
                                <textarea rows={3} className="form-control" name="hasilUji" value={valueHasilUji} onChange={onChangeHasilUji} />
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" size="sm" onClick={() => handleConfirmSaveDtl()}>Simpan</Button>{' '}
                    <Button variant="danger" size="sm" onClick={handleCLoseModalLhpDetil}>
                        Batal
                    </Button>
                </Modal.Footer>
                {
                    showConfirmSaveDtl &&
                    <SweetAlert
                        title="Simpan Data LHP Detail ?"
                        warning
                        showCancel
                        confirmBtnText={
                            loadingSave ? (
                                <>
                                    <Spinner animation="border" size="sm" className="me-2" />
                                    Proses Simpan...
                                </>
                            ) : (
                                "Proses"
                            )
                        }
                        confirmBtnBsStyle="primary"
                        cancelBtnText="Batal"
                        cancelBtnBsStyle="secondary"
                        onConfirm={handleClickSaveDtl}
                        onCancel={handleCloseConfirmSaveDtl}
                        focusCancelBtn
                        reverseButtons={true}
                        btnSize="sm"
                        disabled={loadingSave}
                    >
                        {loadingSave && (
                            <div className="text-center">
                                <Spinner animation="border" variant="primary" />
                                <p className="mt-2">Proses data, harap tunggu...</p>
                            </div>
                        )}
                    </SweetAlert>
                }
                {
                    showSaveSuccess &&
                    <SweetAlert
                        title="Simpan LHP Detail Berhasil"
                        success
                        onConfirm={handleClickSaveSuccess}
                        btnSize="sm"
                    />
                }
                {
                    showSaveFailed &&
                    <SweetAlert
                        title="Simpan LHP Detail Gagal"
                        danger
                        onConfirm={handleClickSaveFailed}
                        btnSize="sm"
                        timeout={2000}
                    />
                }
            </Modal>
        </>
    )
}

export default ModalLhpNonLalinDetilPeriksa